import {Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core'
import {saveAs} from 'file-saver/FileSaver';
import {DatePipe} from '@angular/common';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import 'rxjs/add/operator/toPromise';
import 'rxjs/Rx';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

import {InvoicesService} from 'app/shared/services/invoices.service';
import {ExpressPayService} from 'app/shared/services/expresspay.service';
import { AlertsService } from 'app/shared/services/alerts.service';

@Component({
  selector: 'app-invoice-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss', './detail.component.styl'],
  encapsulation: ViewEncapsulation.None
})

export class DetailComponent implements OnInit {

  //Invoice Object.
  public renderValue;
  public error;

  //Invoice ID
  private id;

  //FormGroup
  public rForm: FormGroup;

  //PDF Pagination
  public page: number = 1;
  public totalPages: number;
  isLoaded: boolean = false;

  //Radiobuttons
  isAccepted: boolean = false;

  //NOUISlider params.
  public disabled: boolean = false;
  public someValue: number = 15;
  public someMin: number = 1;
  public someMax: number = 30;

  //ExpressPay + Modal
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  public mr: NgbModalRef;

  public expressPay = {
    cost: 0,
    amount: 0,
    new_due_date: ''
  };

  //BankID

  @ViewChild('bankIdModalContent') bankIdModalContent: TemplateRef<any>;
  public bimr: NgbModalRef;

  constructor(private invoicesService: InvoicesService,
    private expressPayService: ExpressPayService,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private fb: FormBuilder,
    private expressPayModal: NgbModal,
    private alertService: AlertsService
    ) {
  }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.renderValue = data.invoice.data;
      this.rFormInit();
    });
  }

  rFormInit() {
    this.rForm = new FormGroup({
      'company': new FormControl({value: this.renderValue.company.name, disabled: true}),
      'customer': new FormControl({value: this.renderValue.customer.name, disabled: true}),
      'id': new FormControl({value: this.renderValue._id, disabled: false}),
      'status': new FormControl({value: this.renderValue.status, disabled: true}),
      'invoice_id': new FormControl({value: this.renderValue.invoice_id, disabled: true}),
      'amount': new FormControl({value: this.renderValue.amount, disabled: true}),
      'tax_amount': new FormControl({value: this.renderValue.tax_amount, disabled: true}),
      'legal_monetary_total': new FormGroup({
        'payable_amount': new FormControl({
          value: this.renderValue.legal_monetary_total.payable_amount,
          disabled: true
        }),
      }),
      'number_of_rows': new FormControl({value: this.renderValue.number_of_rows, disabled: true}),
      'issue_date': new FormControl({value: this.formatDate(this.renderValue.issue_date), disabled: true}),
      'due_date': new FormControl({value: this.formatDate(this.renderValue.due_date), disabled: true}),
      'created_at': new FormControl({value: this.formatDate(this.renderValue.created_at), disabled: true}),
      'customer_comment': new FormControl({
        value: [this.renderValue.customer_comment],
        disabled: this.isAccepted
      }, [Validators.required, Validators.minLength(5)]),
      'peppol_validator': new FormControl({value: [this.renderValue.peppol_validator], disabled: true}),
      'customer_validator': new FormControl({value: [this.renderValue.customer_validator], disabled: true}),
      'xml': new FormControl({value: [this.renderValue.xml], disabled: true}),
      'accept': new FormControl({value: [this.renderValue.accept], disabled: false}, [Validators.required])
    });

    this.setExpressPayValues();
  }

  formatDate(date) {
    const datePipe = new DatePipe('en-US');
    const raw = new Date(date);
    return datePipe.transform(raw, 'y-MM-dd');
  }

  sendInvoice(invoice: any): void {

    if (invoice.accept == 'true' && invoice.sell == 'false') {

      this.updateInvoiceStatus(invoice.id, 'Sending');

    } else if (invoice.accept == 'true' && invoice.sell == 'true') {

      this.openBankIdModal();

    } else if (invoice.accept == 'true' && invoice.add == 'true') {

      this.updateInvoiceStatus(invoice.id, 'Express Pay');
      this.createExpressPayInvoice(invoice, 'Ready to send');

    } else if (invoice.accept == 'true') {

      this.updateInvoiceStatus(invoice.id, 'Sending');

    } else {

      this.updateInvoiceStatusWithComment(invoice.id, invoice.customer_comment, 'Canceled');

    }
  }

  downloadAsFile(name, xml) {
    const filename = name;
    const blob = new Blob([xml], {type: 'application/xml'});
    saveAs(blob, filename);
  }

  updateInvoiceStatus(id, status): void {

    const invoice = {
      id: id,
      status: status
    };

    this.invoicesService.putInvoice(invoice)
      .then((invoice) => {
        this.renderValue = invoice.data;
        this.rForm.get('status').setValue(this.renderValue.status);
        this.renderValue = Object.assign({}, this.renderValue);
        if (this.renderValue.status != 'Express Pay') {
          this.invokeSuccessMessage();
        }
      }).catch(error => this.error = error);
  }

  updateInvoiceStatusWithComment(id, comment, status): void {

    const invoice = {
      id: id,
      status: status,
      customer_comment: comment
    };

    this.invoicesService.putInvoice(invoice)
      .then((invoice) => {
        this.renderValue = invoice.data;
        this.rForm.get('status').setValue(this.renderValue.status);
        this.renderValue = Object.assign({}, this.renderValue);
        this.invokeSuccessMessage();
      }).catch(error => this.error = error);
  }

  invokeSuccessMessage() {
    const that = this;
    this.alertService.success('Success-Info')
    .then((event) => {
      if (event.value) {
        this.router.navigate(['/invoices/list']);
      }
    });
  }

  invokeInfoMessage(id, status) {
    const that = this;
    this.alertService.warning( 'Credit-Info', 'Are you sure?', 'Cancel', 'Continue')
    .then(function (event) {
      if (event.value) {
        that.updateInvoiceStatus(id, status);
        that.router.navigate(['/invoices/upload']);
      }
    }, function (dismiss) {

    });
  }

  afterLoadComplete(pdfData: any) {
    this.totalPages = pdfData.numPages;
    this.isLoaded = true;
  }

  nextPage() {
    this.page++;
  }

  prevPage() {
    this.page--;
  }

  checkValue(value) {
    this.isAccepted = value;
    if (this.isAccepted) {
      this.rForm.get('customer_comment').disable();
    } else {
      this.rForm.get('customer_comment').enable();
    }
    return;
  }

  getExpressPayDate(days) {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return this.formatDate(date);
  }

  setExpressPayValues() {
    this.expressPay.cost = this.renderValue.amount * ((this.someMax - this.someValue + 1) / 100);
    this.expressPay.amount = this.renderValue.amount - this.expressPay.cost;
    this.expressPay.new_due_date = this.renderValue.due_date;
  }

  sliderOnChange() {
    this.expressPay.cost = this.renderValue.amount * ((this.someMax - this.someValue + 1) / 100);
    this.expressPay.amount = this.renderValue.amount - this.expressPay.cost;
    this.expressPay.new_due_date = this.getExpressPayDate(this.someValue);
  }

  cancelExpressPayInvoice(invoice: any) {
    this.mr.close();
    invoice.sell = 'false';
    this.sendInvoice(invoice);
  }

  sellExpressPayInvoice(invoice: any) {
    this.mr.close();
    invoice.sell = 'true';
    this.sendInvoice(invoice);
  }

  addExpressPayInvoice(invoice: any) {
    this.mr.close();
    invoice.add = 'true';
    this.sendInvoice(invoice);
  }

  createExpressPayInvoice(expressPayInvoice: any, expresspayStatus) {
    const EP = {
      invoice_id: expressPayInvoice.id,
      company_id: this.renderValue.company._id,
      customer_id: this.renderValue.customer._id,
      ep_status: expresspayStatus,
      ep_amount: this.expressPay.amount,
      ep_cost: this.expressPay.cost,
      ep_due_date: this.expressPay.new_due_date
    };

    const that = this;
    this.expressPayService.postInvoice(EP).then(function (invoice) {
      that.invokeSuccessMessage();
    }).catch(error => this.error = error);
  }

  openBankIdModal(): void {
    this.bimr = this.expressPayModal.open(this.bankIdModalContent, {size: 'lg'});
  }

  closeBankIdModal(invoice: any): void {
    this.bimr.close();
    this.updateInvoiceStatus(invoice.id, 'Express Pay');
    this.createExpressPayInvoice(invoice, 'Waiting Approval');
  }
}



// WEBPACK FOOTER //
// /app/src/app/client/invoices/detail/detail.component.ts